import React from "react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * PublicRoute — a drop-in replacement for ProtectedRoute that NEVER redirects
 * to /login. Guests (anonymous visitors) can access every feature with a
 * server-minted X-Guest-Id quota. Login remains available but is no longer
 * mandatory to use the app.
 *
 * The only reason this still consumes `useAuth()` is to wait for the initial
 * `/auth/me` check to settle so pages that key off `user` don't flicker.
 */
export default function ProtectedRoute({ children }) {
  const { loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center starfield">
        <div className="text-gold font-serif text-xl animate-pulse">Loading the cosmos...</div>
      </div>
    );
  }
  return children;
}
